export default __webpack_public_path__ + "static/media/Tria Logo_Primary.33280f3c.png";